<div class="inner-content" ridangoAppTrapFocus>
    <div class="flex-align-center inset-0 !flex">
        <div
            class="flex-column vl-app-light-dark:!h-auto sr-app-light-dark:!h-auto flex h-full w-full rounded-2xl bg-white dark:border-2 dark:border-solid dark:border-contrast-yellow">
            <div class="flex-align-center align-center !flex justify-center p-4 font-bold">
                {{ 'ACCOUNT_DELETION_MODAL_TITLE' | translate }}
            </div>

            <div class="content box-border flex-1 overflow-y-auto p-4">
                <div class="overflow-y-auto dark:text-contrast-yellow">
                    <p>{{ 'ACCOUNT_DELETION_MODAL_DESCRIPTION_1' | translate }}</p>
                    <p>{{ 'ACCOUNT_DELETION_MODAL_DESCRIPTION_2' | translate }}</p>

                    <div class="my-4 rounded-lg bg-grey-white_smoke p-4 dark:bg-contrast-black">
                        <p class="orb-app-light:text-red-bright text-red font-bold dark:text-contrast-yellow">
                            {{ 'ACCOUNT_DELETION_MODAL_LIST_TITLE' | translate }}
                        </p>

                        <div class="orb-app-light:text-red-bright text-red modal-list dark:text-contrast-yellow">
                            <ul class="list-disc pl-4" innerHtml="{{ 'ACCOUNT_DELETION_MODAL_LIST' | translate }}"></ul>
                        </div>
                    </div>

                    <p *ngIf="env.ACCOUNT_DELETE_CONFIRM_TYPE === accountDeleteConfirmationType.CONFIRM_WITH_EMAIL">
                        {{ 'ACCOUNT_DELETION_MODAL_CONFIRMATION_TEXT' | translate }}
                    </p>

                    <div
                        class="my-2"
                        *ngIf="env.ACCOUNT_DELETE_CONFIRM_TYPE === accountDeleteConfirmationType.CONFIRM_WITH_TICKBOX">
                        <span class="flex-align-center flex gap-2">
                            <div class="checkbox-wcag">
                                <input
                                    class="checkbox-wcag__checkbox vl-app-light:accent-secondary vl-app-light:min-w-[16px] vl-app-light:h-4 accent-primary"
                                    [checked]="accountDeletionConfirmed"
                                    (change)="toggleDeleteConfirmCheckbox()"
                                    type="checkbox"
                                    attr.aria-hidden="true"
                                    tabindex="-1"
                                    attr.aria-label="{{ 'READ_TERMS_CHECKBOX_ARIA_LABEL' | translate }}" />
                                <span
                                    class="checkbox-wcag__checkmark"
                                    [class.ng-glass]="isContrast$ | async"
                                    (click)="toggleDeleteConfirmCheckbox()"
                                    tabindex="0"
                                    attr.aria-checked="{{ accountDeletionConfirmed }}"
                                    role="checkbox"
                                    attr.aria-label="{{
                                        'ACCOUNT_DELETION_MODAL_CONFIRMATION_CHECKBOX_ARIA_LABEL' | translate
                                    }}">
                                </span>
                            </div>
                            <label class="text-xs font-semibold text-black dark:text-contrast-yellow">
                                <span
                                    class="link-label font-medium"
                                    (click)="toggleDeleteConfirmCheckbox()"
                                    (keydown.enter)="toggleDeleteConfirmCheckbox()"
                                    (keydown.space)="toggleDeleteConfirmCheckbox()">
                                    {{ 'ACCOUNT_DELETION_MODAL_CONFIRMATION_CHECKBOX' | translate }}
                                </span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>

            <div class="align-center px-4">
                <button
                    class="vl-app-light:bg-[var(--btn-primary-color)] vl-app-light:text-black h-14 w-full rounded-lg bg-secondary font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                    *ngIf="env.ACCOUNT_DELETE_CONFIRM_TYPE === accountDeleteConfirmationType.CONFIRM_WITH_EMAIL"
                    [attr.aria-label]="'ACCOUNT_DELETION_MODAL_BUTTON' | translate"
                    (click)="confirmDelete()"
                    (keydown.enter)="confirmDelete()"
                    (keydown.space)="confirmDelete()"
                    tabindex="0">
                    {{ 'ACCOUNT_DELETION_MODAL_BUTTON' | translate }}
                </button>

                <button
                    class="orb-app-light:bg-danger orb-app-light:text-white var-app-light:bg-red-600 var-app-light:text-white h-14 w-full rounded-lg font-bold dark:bg-contrast-yellow dark:text-contrast-black"
                    *ngIf="env.ACCOUNT_DELETE_CONFIRM_TYPE === accountDeleteConfirmationType.CONFIRM_WITH_TICKBOX"
                    [class]="
                        !accountDeletionConfirmed
                            ? (isContrast$ | async)
                                ? 'disabled-button-contrast'
                                : 'disabled-button'
                            : ''
                    "
                    [disabled]="!accountDeletionConfirmed"
                    [attr.aria-label]="'ACCOUNT_DELETION_MODAL_BUTTON' | translate"
                    (click)="confirmDelete()"
                    (keydown.enter)="confirmDelete()"
                    (keydown.space)="confirmDelete()"
                    tabindex="0">
                    {{ 'ACCOUNT_DELETION_MODAL_BUTTON' | translate }}
                </button>

                <button
                    class="vl-app-light:text-primary var-app-light:text-primary h-14 w-full font-medium text-secondary dark:!text-contrast-yellow"
                    [attr.aria-label]="'ACCOUNT_DELETION_MODAL_CANCEL' | translate"
                    (click)="cancelDelete()"
                    (keydown.enter)="cancelDelete()"
                    (keydown.space)="cancelDelete()"
                    tabindex="0">
                    {{ 'ACCOUNT_DELETION_MODAL_CANCEL' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
